<template>
  <section
    class="features-tiles section"
    :class="[
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color'
    ]"
  >
    <div class="container">
      <div
        class="features-tiles-inner section-inner"
        :class="[
          topDivider && 'has-top-divider',
          bottomDivider && 'has-bottom-divider'
        ]"
      >
        <c-section-header :data="sectionHeader" />
        <div class="tiles-wrap" :class="[pushLeft && 'push-left']">
          <div class="tiles-item reveal-from-right">
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div class="features-tiles-item-image mb-16">
                  <c-image
                    :src="require('@/assets/images/feature-tile-icon-01.svg')"
                    alt="Feature tile icon 01"
                    :width="72"
                    :height="72"
                  />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4 class="mt-0 mb-16">Web Apps that replace spreadsheets</h4>
                <p class="m-0 text-sm">
                  A custom web app minimizes data entry
                  errors and prevents one user from overwriting the work of
                  another by mistake.
                </p>
              </div>
            </div>
          </div>

          <div class="tiles-item reveal-from-left">
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div class="features-tiles-item-image mb-16">
                  <c-image
                    :src="require('@/assets/images/feature-tile-icon-03.svg')"
                    alt="Feature tile icon 02"
                    :width="72"
                    :height="72"
                  />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4 class="mt-0 mb-16">Web Apps that replace Airtable or Zapier</h4>
                <p class="m-0 text-sm">
                  Airtable gets slow and, let's be honest, insecure. A
                  custom web app, carefully locked down, mitigates security
                  risks.
                </p>
              </div>
            </div>
          </div>

          <div class="tiles-item reveal-from-right">
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div class="features-tiles-item-image mb-16">
                  <c-image
                    :src="require('@/assets/images/feature-tile-icon-05.svg')"
                    alt="Feature tile icon 03"
                    :width="72"
                    :height="72"
                  />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4 class="mt-0 mb-16">Web Apps that replace Wordpress</h4>
                <p class="m-0 text-sm">
                  Wordpress sites become a mess of plugins, load slowly, get hacked
                  easily, and make adding custom features very hard.
                </p>
              </div>
            </div>
          </div>

          <div class="tiles-item reveal-from-left">
            <div class="tiles-item-inner">
              <div class="features-tiles-item-header">
                <div class="features-tiles-item-image mb-16">
                  <c-image
                    :src="require('@/assets/images/feature-tile-icon-04.svg')"
                    alt="Feature tile icon 04"
                    :width="72"
                    :height="72"
                  />
                </div>
              </div>
              <div class="features-tiles-item-content">
                <h4 class="mt-0 mb-16">Web Apps that do things no other software does</h4>
                <p class="m-0 text-sm">
                  Completely customized business process workflows? Check.
                  Dynamic calculations based on dozens of variables? Check.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionTilesProps } from "@/utils/SectionProps.js";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
import CImage from "@/components/elements/Image.vue";

export default {
  name: "CFeaturesTiles",
  components: {
    CSectionHeader,
    CImage
  },
  mixins: [SectionTilesProps],
  data() {
    return {
      sectionHeader: {
        title: `Turn your client's wireframes into a working 'MVP' (Minimum Viable Product) web app.`,
        paragraph: `<a href="/about">I'm Dima</a>. I'm a native English speaker like you. I join you in meetings to ask technical questions. But you run the show. That means you end up with a functional solution that <strong>you</strong> present to your client for review.`
      }
    };
  }
};
</script>
